<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" v-if="header"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content" class="plp hasLogo tabWrap">
        <!-- 클래스추가 -->
        <ul class="tabList pageTab">
          <li @click="$router.push('/')">홈</li>
          <!-- <li :class="{ on: tab == 'benefits' }" @click="tab = 'benefits'" ref="benefits">나만의 혜택</li> -->
          <li :class="{ on: tab == 'theme' }" @click="tab = 'theme'" ref="theme">기획전</li>
          <!-- <li :class="{ new: true, on: tab == 'productSalePrice' }" @click="tab = 'productSalePrice'" ref="productSalePrice">초특가렌탈</li> -->
          <!-- <li :class="{ on: tab == 'deliveryMain' }" @click="tab = 'deliveryMain'" ref="deliveryMain">정기배송</li> -->
          <li :class="{ on: tab == 'event' }" @click="tab = 'event'" ref="event">이벤트</li>
          <!-- <li>고객서비스</li> -->
        </ul>

        <BenefitsMain v-if="tab == 'benefits'"></BenefitsMain>
        <ThemeMain v-if="tab == 'theme'"></ThemeMain>
        <ProductSalePrice v-if="tab == 'productSalePrice'"></ProductSalePrice>
        <DeliveryMain v-if="tab == 'deliveryMain'"></DeliveryMain>
        <EventMain v-if="tab == 'event'"></EventMain>

        <!-- 정기배송 -->

        <!-- content(e) -->
        <Footer></Footer>
      </div>
    </div>
    <!-- container(e) -->
    <QuickMenu></QuickMenu>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import QuickMenu from '@/views/app/comm/QuickMenu';
import * as customjs from '@/../static/js/m.front.js';
import BenefitsMain from '@/views/app/benefits/BenefitsMain';
import ThemeMain from '@/views/app/theme/ThemeMain';
import ProductSalePrice from '@/views/app/product/ProductSalePrice';
import DeliveryMain from '@/views/app/order/delivery/DeliveryMain';
import EventMain from '@/views/app/event/EventMain';
import Footer from '@/views/app/comm/Footer';

export default {
  name: 'SubMain',
  components: {
    BenefitsMain,
    ThemeMain,
    ProductSalePrice,
    DeliveryMain,
    EventMain,
    QuickMenu,
    Footer,
  },
  data: function() {
    return {
      header: false,
      tab: null, // 탭구분 (나만의 혜택, 기획전, 초특가렌탈, 이벤트)
    };
  },
  watch: {
    tab() {
      if (this.tab != this.$route.params.subTitle) this.$router.replace('/submain/' + this.tab);
    },
  },
  mounted() {
    const title = this.$route.params.subTitle;

    this.$refs[title].focus();
    this.tab = title;
    customjs.addStiky('.tabList.pageTab');
    this.header = true;
  },
};
</script>
